import { render, staticRenderFns } from "./ReceptionModal.vue?vue&type=template&id=6b91be85&scoped=true"
import script from "./ReceptionModal.vue?vue&type=script&lang=js"
export * from "./ReceptionModal.vue?vue&type=script&lang=js"
import style0 from "./ReceptionModal.vue?vue&type=style&index=0&id=6b91be85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b91be85",
  null
  
)

export default component.exports